import type { AxiosResponse } from 'axios';
import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { keyBy } from 'es-toolkit';
import { atom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getUserBlockApi } from '@flipster/apis/v1/user';
import { GetUserBlockResponse, UserBlockServiceEnum } from '@flipster/apis/v1/user/types';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { authBunja } from '../auth/state';

export const userBlockBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { isLoggedInAtom } = bunja.use(authBunja);
  const userBlockBaseAtom = atomWithQuery((get) => {
    return {
      queryKey: ['getUserBlockApi', 'allServiceType'],
      queryFn: () => getUserBlockApi({ serviceType: Object.values(UserBlockServiceEnum) }),
      select: (res: AxiosResponse<GetUserBlockResponse>) => keyBy(res.data.userBlockInfos, (v) => v.serviceType),
      enabled: get(isLoggedInAtom),
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      experimental_prefetchInRender: true,
    };
  });
  const userBlockListAtom = atom((get) => get(userBlockBaseAtom).data);
  const promiseAtom = atom((get) => ({ promise: get(userBlockBaseAtom).promise }));
  function refetch() {
    const { refetch } = store.get(userBlockBaseAtom);
    return refetch();
  }
  bunja.effect(() => store.sub(userBlockBaseAtom, () => {}));
  return { userBlockListAtom, promiseAtom, refetch };
});
userBlockBunja.debugLabel = 'userBlockBunja';

export function useUserBlock() {
  const { userBlockListAtom, refetch: refetchBlock } = useBunja(userBlockBunja);
  const userBlockList = useAtomValue(userBlockListAtom);
  return { userBlockList, refetchBlock };
}
